module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "join-our-team.537b2d35.webp" + "?" + Date.now();